import { AlertTriangle } from 'lucide-react';

export function StorageDisabledBanner(): React.ReactElement {
  return (
    <div className="flex items-start gap-2 rounded-md border border-warning/30 bg-warning/15 p-3 text-sm text-warning">
      <AlertTriangle className="mt-0.5 size-4 shrink-0" />
      <div>
        <div className="font-semibold">Artifact storage is disabled</div>
        <div className="text-warning/80">
          This deployment is using SQLite. Artifacts require Postgres. Set{' '}
          <code className="rounded bg-warning/15 px-1">DATABASE_URL</code> and restart the server,
          or switch to a Postgres-backed environment.
        </div>
      </div>
    </div>
  );
}
